<template>
  <div :class="$style.wrapper">
    <button type="button" :class="[hasUnderline && $style.underline]" @click="isShow = true">
      <slot name="link" />
    </button>
    <IModal v-model="isShow" width="660px">
      <slot name="dialog" />
    </IModal>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import IModal from '@/js/components/molecules/IModal.vue';

defineProps<{
  hasUnderline?: boolean;
}>();
const isShow = ref(false);
</script>

<style module lang="scss">
.wrapper {
  display: inline-block;
}

.underline {
  border-bottom: 1px dashed var(--color-gray900);
}
</style>
